import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {injectIntl, intlShape, defineMessages} from 'react-intl';

import decksLibraryContent from '../lib/libraries/decks/index-card.jsx';
import cardTags from '../lib/libraries/card-tags';

import analytics from '../lib/analytics';
import {notScratchDesktop} from '../lib/isScratchDesktop';

import LibraryComponent from '../components/library/library.jsx';

import {connect} from 'react-redux';

import {
    closeCardsLibrary
} from '../reducers/modals';

import {
    activateDeck
} from '../reducers/cards';

import {closeConnectionModalMenu} from '../reducers/modals';

const messages = defineMessages({
    cardsLibraryTitle: {
        defaultMessage: 'Choose a Board',
        description: 'Heading for the help/tutorials library',
        id: 'gui.cardsLibrary.ChooseCard'
    }
});

class CardsLibrary extends React.PureComponent {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleItemSelect'
        ]);
    }

    handleItemSelect (item) {
        var storage = window.localStorage;
        storage.setItem("CardType", item.id); 
        storage.setItem("CardTypeName", item.name); 

        //commandToCard.setCardType(item.id, item.name);
        window.api.send("setCardType", [item.id, item.name]);
    }

    render () {
        const decksLibraryThumbnailData = Object.keys(decksLibraryContent)
            .filter(id => {
                if (notScratchDesktop()) return true; // Do not filter anything in online editor
                const deck = decksLibraryContent[id];
                // Scratch Desktop doesn't want tutorials with `requiredProjectId`
                if (deck.hasOwnProperty('requiredProjectId')) return false;
                // Scratch Desktop should not load tutorials that are _only_ videos
                if (deck.steps.filter(s => s.title).length === 0) return false;
                // Allow any other tutorials
                return true;
            })
            .map(id => ({
                rawURL: decksLibraryContent[id].img,
                id: id,
                name: decksLibraryContent[id].name,
                featured: true,
                tags: decksLibraryContent[id].tags,
                urlId: decksLibraryContent[id].urlId,
                requiredProjectId: decksLibraryContent[id].requiredProjectId,
                hidden: decksLibraryContent[id].hidden || false
            }));

        if (!this.props.visible) return null;
        return (
            <LibraryComponent
                filterable
                data={decksLibraryThumbnailData}
                id="cardsLibrary"
                tags={cardTags}
                title={this.props.intl.formatMessage(messages.cardsLibraryTitle)}
                visible={this.props.visible}
                onItemSelected={this.handleItemSelect}
                onRequestClose={this.props.onRequestClose}
            />
        );
    }
}

CardsLibrary.propTypes = {
    intl: intlShape.isRequired,
    onActivateDeck: PropTypes.func.isRequired,
    onRequestClose: PropTypes.func,
    projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    visible: PropTypes.bool
};

const mapStateToProps = state => ({
    visible: state.scratchGui.modals.cardsLibrary,
    projectId: state.scratchGui.projectState.projectId
});

const mapDispatchToProps = dispatch => ({
    onActivateDeck: id => dispatch(activateDeck(id)),
    onRequestClose: () => dispatch(closeCardsLibrary()),
    onCloseConnectionModal: () => dispatch(closeConnectionModalMenu())
});

export default injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps
)(CardsLibrary));
